export default __webpack_public_path__ + "static/media/statue-antinous.dbd45af3.webp";